(() => {
  const VERSION = '2026-10-13.1';
  if (customElements.get('avontic-galaxy-tab-finder')) return;

  // Samsung device identities were checked against official Samsung support/product sources on 2026-08-19.
  // The option labels remain the merchant's authoritative statement of this product's offered case compatibility.
  const MODELS = Object.freeze([
    { options: ['S11 Ultra 14.6"', 'Galaxy Tab S11 Ultra (14.6″)'], device: 'Galaxy Tab S11 Ultra (14.6″)', codes: ['SM-X930', 'SM-X936'], aliases: ['Galaxy Tab S11 Ultra', 'Tab S11 Ultra', 'S11 Ultra'] },
    { options: ['S11 2025 11"', 'Galaxy Tab S11 (11.0″)'], device: 'Galaxy Tab S11 (11.0″)', codes: ['SM-X730', 'SM-X736'], aliases: ['Galaxy Tab S11', 'Tab S11', 'S11'] },
    { options: ['S10 Ultra 14.6"', 'Galaxy Tab S10 Ultra (14.6″)'], device: 'Galaxy Tab S10 Ultra (14.6″)', codes: ['SM-X920', 'SM-X926'], aliases: ['Galaxy Tab S10 Ultra', 'Tab S10 Ultra', 'S10 Ultra'] },
    { options: ['Tab S10 Plus 12.4"', 'Galaxy Tab S10+ (12.4″)', 'Galaxy Tab S10+ 12.4" (SM-X820 / X826 / X828)'], device: 'Galaxy Tab S10+ (12.4″)', codes: ['SM-X820', 'SM-X826'], aliases: ['Galaxy Tab S10+', 'Galaxy Tab S10 Plus', 'Tab S10+', 'Tab S10 Plus', 'S10+', 'S10 Plus'] },
    { options: ['S10 FE Plus 13.1"', 'Galaxy Tab S10 FE+ (13.1″)'], device: 'Galaxy Tab S10 FE+ (13.1″)', codes: ['SM-X620', 'SM-X626'], aliases: ['Galaxy Tab S10 FE+', 'Galaxy Tab S10 FE Plus', 'Tab S10 FE+', 'Tab S10 FE Plus', 'S10 FE+', 'S10 FE Plus'] },
    { options: ['S10 FE 10.9"', 'Galaxy Tab S10 FE (10.9″)'], device: 'Galaxy Tab S10 FE (10.9″)', codes: ['SM-X520', 'SM-X526'], aliases: ['Galaxy Tab S10 FE', 'Tab S10 FE', 'S10 FE'] },
    { options: ['S10 Lite 10.9"', 'Galaxy Tab S10 Lite (10.9″)'], device: 'Galaxy Tab S10 Lite (10.9″)', codes: ['SM-X400', 'SM-X406'], aliases: ['Galaxy Tab S10 Lite', 'Tab S10 Lite', 'S10 Lite'] },
    { options: ['S9 Ultra 14.6"', 'Galaxy Tab S9 Ultra (14.6″)'], device: 'Galaxy Tab S9 Ultra (14.6″)', codes: ['SM-X910', 'SM-X916'], aliases: ['Galaxy Tab S9 Ultra', 'Tab S9 Ultra', 'S9 Ultra'] },
    { options: ['Tab S9 Plus 12.4"', 'Galaxy Tab S9+ (12.4″)', 'Galaxy Tab S9+ 12.4" (SM-X810 / X816)'], device: 'Galaxy Tab S9+ (12.4″)', codes: ['SM-X810', 'SM-X816'], aliases: ['Galaxy Tab S9+', 'Galaxy Tab S9 Plus', 'Tab S9+', 'Tab S9 Plus', 'S9+', 'S9 Plus'] },
    { options: ['Tab S9 FE Plus 12.4"', 'Galaxy Tab S9 FE+ (12.4″)', 'Galaxy Tab S9 FE+ 12.4" (SM-X610 / X616)'], device: 'Galaxy Tab S9 FE+ (12.4″)', codes: ['SM-X610', 'SM-X616'], aliases: ['Galaxy Tab S9 FE+', 'Galaxy Tab S9 FE Plus', 'Tab S9 FE+', 'Tab S9 FE Plus', 'S9 FE+', 'S9 FE Plus'] },
    { options: ['S9 11 S9 FE 10.9"', 'Galaxy Tab S9 (11.0″)', 'Galaxy Tab S9 11" (SM-X710 / X716 / X718)', 'Tab S9 11in'], device: 'Galaxy Tab S9 (11.0″)', codes: ['SM-X710', 'SM-X716'], aliases: ['Galaxy Tab S9', 'Tab S9', 'S9'] },
    { options: ['S9 11 S9 FE 10.9"', 'Galaxy Tab S9 FE (10.9″)', 'Galaxy Tab S9 FE 10.9" (SM-X510 / X516)'], device: 'Galaxy Tab S9 FE (10.9″)', codes: ['SM-X510', 'SM-X516'], aliases: ['Galaxy Tab S9 FE', 'Tab S9 FE', 'S9 FE'] },
    { options: ['S8 Ultra 14.6"', 'Galaxy Tab S8 Ultra (14.6″)'], device: 'Galaxy Tab S8 Ultra (14.6″)', codes: ['SM-X900', 'SM-X906'], aliases: ['Galaxy Tab S8 Ultra', 'Tab S8 Ultra', 'S8 Ultra'] },
    { options: ['Tab S8 Plus 12.4"', 'Galaxy Tab S8+ (12.4″)', 'Galaxy Tab S8+ 12.4" (SM-X800 / X806)'], device: 'Galaxy Tab S8+ (12.4″)', codes: ['SM-X800', 'SM-X806'], aliases: ['Galaxy Tab S8+', 'Galaxy Tab S8 Plus', 'Tab S8+', 'Tab S8 Plus', 'S8+', 'S8 Plus'] },
    { options: ['Tab S7 11 S8 11"', 'Galaxy Tab S8 (11.0″)', 'Galaxy Tab S8 11" (SM-X700 / X706)', 'Tab S8 11in'], device: 'Galaxy Tab S8 (11.0″)', codes: ['SM-X700', 'SM-X706'], aliases: ['Galaxy Tab S8', 'Tab S8', 'S8'] },
    { options: ['Tab S7 11 S8 11"', 'Galaxy Tab S7 (11.0″)', 'Galaxy Tab S7 11" (SM-T870 / T875 / T878)', 'Tab S7 11in'], device: 'Galaxy Tab S7 (11.0″)', codes: ['SM-T870', 'SM-T875', 'SM-T876', 'SM-T878'], aliases: ['Galaxy Tab S7', 'Tab S7', 'S7'] },
    { options: ['Tab S7 Plus 12.4"', 'Galaxy Tab S7+ (12.4″)', 'Galaxy Tab S7+ 12.4" (SM-T970 / T975 / T976)'], device: 'Galaxy Tab S7+ (12.4″)', codes: ['SM-T970', 'SM-T975', 'SM-T976', 'SM-T978'], aliases: ['Galaxy Tab S7+', 'Galaxy Tab S7 Plus', 'Tab S7+', 'Tab S7 Plus', 'S7+', 'S7 Plus'] },
    { options: ['Tab S7 FE 12.4"', 'Galaxy Tab S7 FE (12.4″)', 'Galaxy Tab S7 FE 12.4" (SM-T730 / T733 / T736)'], device: 'Galaxy Tab S7 FE (12.4″)', codes: ['SM-T730', 'SM-T733', 'SM-T735', 'SM-T736', 'SM-T738'], aliases: ['Galaxy Tab S7 FE', 'Tab S7 FE', 'S7 FE'] },
    { options: ['Galaxy Tab A11+ (11.0″)', 'Galaxy Tab A11+ 11" (SM-X230 / X236)'], device: 'Galaxy Tab A11+ (11.0″)', codes: ['SM-X230', 'SM-X236', 'SM-X238'], aliases: ['Galaxy Tab A11+', 'Galaxy Tab A11 Plus', 'Tab A11+', 'Tab A11 Plus', 'A11+', 'A11 Plus'] },
    { options: ['Galaxy Tab A11 (8.7″)', 'Galaxy Tab A11 / A9 (8.7″)', 'Galaxy Tab A11 8.7" (SM-X130 / X133 / X135)'], device: 'Galaxy Tab A11 (8.7″)', codes: ['SM-X130', 'SM-X133', 'SM-X135'], aliases: ['Galaxy Tab A11', 'Tab A11', 'A11'] },
    { options: ['Galaxy Tab A9 (8.7″)', 'Galaxy Tab A11 / A9 (8.7″)', 'Galaxy Tab A9 8.7" (SM-X110 / X115)', 'A9 8.7inch 2023'], device: 'Galaxy Tab A9 (8.7″)', codes: ['SM-X110', 'SM-X115', 'SM-X117'], aliases: ['Galaxy Tab A9', 'Tab A9', 'A9'] },
    { options: ['Galaxy Tab A9+ (11.0″)', 'Galaxy Tab A9+ 11" (SM-X210 / X216)', 'A9 Plus 11inch 2023'], device: 'Galaxy Tab A9+ (11.0″)', codes: ['SM-X210', 'SM-X216', 'SM-X218'], aliases: ['Galaxy Tab A9+', 'Galaxy Tab A9 Plus', 'Tab A9+', 'Tab A9 Plus', 'A9+', 'A9 Plus'] },
    { options: ['Galaxy Tab A8 10.5" (SM-X200 / X205 / X207)', 'Tab A8 10.5in', 'A8 X200 X205 X207'], device: 'Galaxy Tab A8 (10.5″)', codes: ['SM-X200', 'SM-X205', 'SM-X207'], aliases: ['Galaxy Tab A8', 'Tab A8', 'A8'] },
    { options: ['A8 10.5inch'], device: 'Galaxy Tab A8 (10.5″) — alternate listed option', codes: [], aliases: ['Galaxy Tab A8', 'Tab A8', 'A8'] },
    { options: ['A7 10.4inch', 'Tab A7 10.4in'], device: 'Galaxy Tab A7 (10.4″)', codes: ['SM-T500', 'SM-T505', 'SM-T507'], aliases: ['Galaxy Tab A7', 'Tab A7', 'A7'] },
    { options: ['A7 Lite 8.7inch', 'Tab A7 lite 8.7in'], device: 'Galaxy Tab A7 Lite (8.7″)', codes: ['SM-T220', 'SM-T225', 'SM-T227'], aliases: ['Galaxy Tab A7 Lite', 'Tab A7 Lite', 'A7 Lite'] },
    { options: ['S6 lite 10.4inch', 'Tab S6 Lite 10.4in'], device: 'Galaxy Tab S6 Lite (10.4″)', codes: [], aliases: ['Galaxy Tab S6 Lite', 'Tab S6 Lite', 'S6 Lite'] },
    { options: ['T290 T295 T297 8inch'], device: 'Galaxy Tab A 8.0 (2019)', codes: ['SM-T290', 'SM-T295', 'SM-T297'], aliases: ['Galaxy Tab A 8.0 2019', 'Tab A 8.0 2019', 'Tab A 8 2019'] },
    { options: ['T510 T515 10.1inch'], device: 'Galaxy Tab A 10.1 (2019)', codes: ['SM-T510', 'SM-T515'], aliases: ['Galaxy Tab A 10.1 2019', 'Tab A 10.1 2019'] }
  ]);

  const state = window.AvonticGalaxyTabFinderState instanceof Map
    ? window.AvonticGalaxyTabFinderState
    : new Map();
  window.AvonticGalaxyTabFinderState = state;
  const coreFinderState = window.AvonticPdpFinderState instanceof Map
    ? window.AvonticPdpFinderState
    : new Map();
  window.AvonticPdpFinderState = coreFinderState;

  const normalizeName = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[＋]/g, '+')
    .toLowerCase()
    .replace(/\bsamsung\b/g, '')
    .replace(/[”“″"]/g, ' ')
    .replace(/[^a-z0-9+]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');

  const extractModelCode = (value) => {
    const match = String(value || '').toUpperCase().match(/SM[\s-]*([XTP])[\s-]*(\d{3})/);
    return match ? `SM-${match[1]}${match[2]}` : '';
  };

  const extractOptionCodes = (value) => {
    const codes = [];
    const pattern = /\b(?:SM[\s-]*)?([XTP])[\s-]*(\d{3})[A-Z]?\b/gi;
    let match;
    while ((match = pattern.exec(String(value || '')))) codes.push(`SM-${match[1].toUpperCase()}${match[2]}`);
    return [...new Set(codes)];
  };

  const isScreenSizeOnly = (value) => {
    const normalized = String(value || '').toLowerCase().replace(/inches?|inch|screen|size|[”“″"]/g, '').trim();
    return /^(10\.9|11(?:\.0)?|12\.4|13\.1|14\.6)$/.test(normalized);
  };

  const track = (name, payload = {}) => {
    try { window.AvonticAnalytics?.track?.(name, payload); }
    catch (_) { return false; }
    return true;
  };

  class AvonticGalaxyTabFinder extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.config = this.readConfig();
      this.stateKey = String(this.config.productId || this.dataset.productId || '');
      this.details = this.querySelector('details');
      this.input = this.querySelector('[data-av-galaxy-input]');
      this.submitButton = this.querySelector('[data-av-galaxy-submit]');
      this.status = this.querySelector('[data-av-galaxy-status]');
      this.statusTitle = this.querySelector('[data-av-galaxy-status-title]');
      this.statusCopy = this.querySelector('[data-av-galaxy-status-copy]');
      this.choices = this.querySelector('[data-av-galaxy-choices]');
      this.datalist = this.querySelector('[data-av-galaxy-datalist]');
      this.optionMap = new Map((this.config.optionValues || []).map((option) => [String(option.label), option]));
      this.models = MODELS.map((model) => {
        const option = model.options.find((optionName) => this.optionMap.has(optionName));
        const codes = option ? [...new Set([...model.codes, ...extractOptionCodes(option)])] : [];
        return option ? { ...model, option, codes } : null;
      }).filter(Boolean);
      this.populateDatalist();
      this.polishNativePicker();
      this.restoreState();
      this.observeSelectionSummary();
      this.queueSelectionSummaryPolish();

      this.submitButton?.addEventListener('click', () => this.submit(), { signal: this.controller.signal });
      this.input?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.submit();
      }, { signal: this.controller.signal });
      this.details?.addEventListener('toggle', () => {
        this.querySelector('.av-pdp-finder__summary')?.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        if (this.details.open) track('av_galaxy_model_finder_open', { product_id: this.stateKey });
      }, { signal: this.controller.signal });

      document.addEventListener('change', (event) => this.handleNativeChange(event), { capture: true, signal: this.controller.signal });
      document.addEventListener('variant:change', () => {
        this.polishNativePicker();
        this.queueSelectionSummaryPolish();
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.summaryObserver?.disconnect();
    }

    readConfig() {
      try { return JSON.parse(this.querySelector('[data-av-galaxy-config]')?.textContent || '{}'); }
      catch (_) { return {}; }
    }

    populateDatalist() {
      if (!this.datalist) return;
      const fragment = document.createDocumentFragment();
      this.models.forEach((model) => {
        const option = document.createElement('option');
        option.value = model.device.replace(/\s*\([^)]*\)$/, '');
        option.label = `${model.codes.length ? `${model.codes.join(' / ')} · ` : ''}${model.option}`;
        fragment.append(option);
      });
      this.datalist.replaceChildren(fragment);
    }

    polishNativePicker() {
      const productRoot = this.closest('#avontic-primary-product') || document.querySelector('#avontic-primary-product');
      const fieldset = productRoot?.querySelector(`[data-av-explicit-selection-name="${CSS.escape(String(this.config.optionName || 'Size'))}"]`);
      if (!fieldset) return;
      const legend = fieldset.querySelector('.variant-picker__option-info legend');
      const badge = fieldset.querySelector('.av-pdp-required-badge');
      const guidance = fieldset.querySelector('.av-pdp-option-guidance');
      if (legend) {
        legend.dataset.nativeLabel = this.config.optionName || 'Size';
        legend.setAttribute('aria-label', 'Galaxy Tab model');
      }
      if (badge) badge.setAttribute('aria-label', 'Verify fit');
      if (guidance) guidance.textContent = 'Use the finder above or match the complete Galaxy Tab model shown in Settings → About tablet.';
    }

    setStatus(stateName, title, copy, icon = 'i') {
      if (!this.status) return;
      this.status.dataset.state = stateName;
      if (this.statusTitle) this.statusTitle.textContent = title || '';
      if (this.statusCopy) this.statusCopy.textContent = copy || '';
      const iconElement = this.status.querySelector('.av-galaxy-finder__status-icon');
      if (iconElement) iconElement.textContent = icon;
      if (this.details && stateName !== 'verification-required') this.details.open = true;
    }

    resetChoices() {
      if (!this.choices) return;
      this.choices.replaceChildren();
      this.choices.hidden = true;
    }

    selectedOptionValue() {
      const form = document.getElementById(this.config.formId) || document.forms[this.config.formId];
      return Array.from(form?.elements || []).find((element) => (
        element.matches?.(`input[data-option-position="${this.config.optionPosition}"]:checked`)
      ));
    }

    restoreState() {
      const saved = state.get(this.stateKey);
      if (saved?.invalidated) {
        this.setStatus('verification-required', 'Model selection changed', 'Verify this Galaxy Tab option again before ordering.', 'i');
        return;
      }
      if (!saved?.option || String(this.selectedOptionValue()?.value || '') !== String(this.optionMap.get(saved.option)?.id || '')) {
        if (saved) {
          state.delete(this.stateKey);
          coreFinderState.delete(this.stateKey);
        }
        return;
      }
      coreFinderState.set(this.stateKey, {
        modelNumber: saved.code || saved.device || '',
        optionKey: saved.option
      });
      if (this.input) this.input.value = saved.input || saved.code || saved.device || '';
      this.renderVerified(saved);
      window.setTimeout(() => this.emitVerification(true, saved), 0);
      [0, 220, 700].forEach((delay) => window.setTimeout(() => this.polishVerifiedSummary(saved), delay));
    }

    handleNativeChange(event) {
      const control = event.target instanceof Element ? event.target.closest('[data-option-position]') : null;
      const productRoot = this.closest('#avontic-primary-product') || document.querySelector('#avontic-primary-product');
      if (!control || !productRoot?.contains(control)) return;
      if (String(control.dataset.optionPosition || '') !== String(this.config.optionPosition || '')) return;
      const saved = state.get(this.stateKey);
      const savedOption = saved ? this.optionMap.get(saved.option) : null;
      if (savedOption && String(control.value) === String(savedOption.id)) return;
      state.set(this.stateKey, { invalidated: true });
      coreFinderState.delete(this.stateKey);
      this.emitVerification(false);
      this.setStatus('verification-required', 'Model selection changed', 'Verify this Galaxy Tab option again before ordering.', 'i');
      this.queueSelectionSummaryPolish();
    }

    submit() {
      const raw = String(this.input?.value || '').trim();
      this.resetChoices();
      const saved = state.get(this.stateKey);
      if (saved?.option && String(saved.input || saved.code || saved.device || '').trim() !== raw) {
        state.delete(this.stateKey);
        coreFinderState.delete(this.stateKey);
        this.emitVerification(false);
        this.queueSelectionSummaryPolish();
      }
      track('av_galaxy_model_finder_submit', { product_id: this.stateKey, result: 'attempted' });
      if (!raw) {
        this.setStatus('error', 'Enter your Galaxy Tab model', 'Use the model number or complete Device name from Settings → About tablet.', '!');
        return;
      }
      if (isScreenSizeOnly(raw)) {
        this.setStatus('error', 'Screen size alone cannot confirm fit', 'Enter the SM- model number or complete Galaxy Tab name.', '!');
        return;
      }
      if (/^\d{14,16}$/.test(raw.replace(/\s+/g, ''))) {
        this.setStatus('error', 'That appears to be an IMEI or serial number', 'For privacy, use only the model number beginning with SM-.', '!');
        return;
      }

      const code = extractModelCode(raw);
      if (code) {
        const matches = this.models.filter((model) => model.codes.includes(code));
        if (!matches.length) {
          this.setStatus('unavailable', 'No exact option found', `We couldn’t match ${code} to a current case option. Double-check it or contact Avontic before ordering.`, '!');
          track('av_galaxy_model_finder_result', { product_id: this.stateKey, result: 'unsupported_code', model_code: code });
          return;
        }
        if (matches.length > 1) {
          this.renderChoices(matches, raw, 'More than one listed option uses this code — confirm the exact device', { code, source: 'model-number' });
          return;
        }
        this.applyMatch(matches[0], { input: raw, code, source: 'model-number' });
        return;
      }

      const query = normalizeName(raw);
      const exact = this.models.filter((model) => model.aliases.some((alias) => normalizeName(alias) === query));
      if (exact.length === 1) {
        this.renderChoices(exact, raw, 'Device name matched — confirm this option');
        return;
      }
      const candidates = query.length >= 3
        ? this.models.filter((model) => model.aliases.some((alias) => normalizeName(alias).includes(query) || query.includes(normalizeName(alias))))
        : [];
      if (candidates.length) {
        this.renderChoices(candidates, raw, candidates.length === 1 ? 'Confirm this device' : 'Choose the complete device name');
        return;
      }
      this.setStatus('unavailable', 'No exact model found', 'Enter the SM- model number or complete Galaxy Tab name shown in Settings → About tablet.', '!');
      track('av_galaxy_model_finder_result', { product_id: this.stateKey, result: 'name_not_found' });
    }

    renderChoices(matches, raw, title, identity = {}) {
      if (!this.choices) return;
      this.setStatus('verification-required', title, 'We will not change the case option until you confirm the exact device.', 'i');
      const unique = [];
      const seen = new Set();
      matches.forEach((match) => {
        const key = `${match.device}:${match.option}`;
        if (seen.has(key)) return;
        seen.add(key);
        unique.push(match);
      });
      unique.forEach((match) => {
        const row = document.createElement('div');
        row.className = 'av-galaxy-finder__choice';
        const copy = document.createElement('div');
        const name = document.createElement('strong');
        const note = document.createElement('small');
        const button = document.createElement('button');
        name.textContent = match.device;
        note.textContent = `Current case option: ${match.option}`;
        button.type = 'button';
        button.textContent = 'Use this fit';
        button.addEventListener('click', () => this.applyMatch(match, {
          input: raw,
          code: identity.code || '',
          source: identity.source || 'device-name'
        }), { signal: this.controller.signal });
        copy.append(name, note);
        row.append(copy, button);
        this.choices.append(row);
      });
      this.choices.hidden = false;
    }

    async applyMatch(match, identity) {
      const nativeOption = this.optionMap.get(match.option);
      const form = document.getElementById(this.config.formId) || document.forms[this.config.formId];
      const productRoot = this.closest('product-rerender, .product, #avontic-primary-product') || document;
      const picker = productRoot.querySelector(`variant-picker[form-id="${CSS.escape(String(this.config.formId || ''))}"]`)
        || document.querySelector(`variant-picker[form-id="${CSS.escape(String(this.config.formId || ''))}"]`);
      if (!nativeOption || !form || !picker) {
        this.setStatus('error', 'Unable to update the case option', 'Please choose the matching Galaxy Tab model manually or contact Avontic.', '!');
        return;
      }
      if (!nativeOption.available) {
        this.setStatus('unavailable', 'This model is currently unavailable', `${match.device} matches ${match.option}, but that option is not available with the current configuration.`, '!');
        return;
      }

      const record = { option: match.option, device: match.device, input: identity.input || '', code: identity.code || '', source: identity.source || '' };
      state.set(this.stateKey, record);
      coreFinderState.set(this.stateKey, {
        modelNumber: record.code || record.device,
        optionKey: record.option
      });
      const current = this.selectedOptionValue();
      try {
        if (String(current?.value || '') !== String(nativeOption.id)) {
          const checked = Array.from(form.elements)
            .filter((element) => element.matches?.('input[data-option-position]:checked'))
            .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
          const optionValues = checked.map((element) => element.value);
          optionValues[Number(this.config.optionIndex)] = String(nativeOption.id);
          form.dispatchEvent(new CustomEvent('avontic:compatibility-changing', { bubbles: true, detail: { formId: this.config.formId } }));
          if (typeof picker.selectCombination === 'function' && optionValues.filter(Boolean).length === checked.length) {
            await picker.selectCombination({ optionValues, productChange: false });
          } else {
            const candidate = Array.from(form.elements).find((element) => (
              element.matches?.(`input[data-option-position="${this.config.optionPosition}"]`)
              && String(element.value) === String(nativeOption.id)
            ));
            if (!candidate) throw new Error('Native option unavailable');
            candidate.checked = true;
            candidate.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.renderVerified(record);
        this.emitVerification(true, record);
        window.setTimeout(() => this.emitVerification(true, record), 180);
        [0, 220, 700].forEach((delay) => window.setTimeout(() => this.polishVerifiedSummary(record), delay));
        this.resetChoices();
        track('av_galaxy_model_finder_result', { product_id: this.stateKey, result: 'matched', model_code: record.code, option: record.option, source: record.source });
      } catch (_) {
        state.delete(this.stateKey);
        coreFinderState.delete(this.stateKey);
        this.emitVerification(false);
        this.setStatus('error', 'Unable to update the case option', 'Please choose the matching Galaxy Tab model manually or contact Avontic.', '!');
        this.queueSelectionSummaryPolish();
      }
    }

    renderVerified(record) {
      const identifier = record.code || record.device;
      this.setStatus(
        'verified',
        'Exact Galaxy Tab model identified',
        `${identifier} matches ${record.device}. Current case option selected: ${record.option}`,
        '✓'
      );
    }

    polishVerifiedSummary(record) {
      const current = state.get(this.stateKey);
      const nativeOption = this.optionMap.get(record?.option);
      if (!current?.option || current.option !== record?.option || !nativeOption) return;
      if (String(this.selectedOptionValue()?.value || '') !== String(nativeOption.id)) return;
      this.polishSelectionSummary(record);
      document.querySelectorAll(`.av-pdp-sticky-cockpit[data-product-id="${CSS.escape(this.stateKey)}"] .av-pdp-sticky__state`).forEach((element) => {
        element.textContent = 'Model match confirmed';
      });
    }

    observeSelectionSummary() {
      this.summaryObserver?.disconnect();
      const productRoot = this.closest('#avontic-primary-product') || document.querySelector('#avontic-primary-product');
      if (!productRoot || typeof MutationObserver !== 'function') return;
      this.summaryObserver = new MutationObserver((records) => {
        const summaryAdded = records.some((record) => Array.from(record.addedNodes).some((node) => (
          node instanceof Element
          && (node.matches('avontic-pdp-selection-summary') || node.querySelector('avontic-pdp-selection-summary'))
        )));
        if (summaryAdded) this.queueSelectionSummaryPolish();
      });
      this.summaryObserver.observe(productRoot, { childList: true, subtree: true });
    }

    queueSelectionSummaryPolish(record = null) {
      [0, 180, 650].forEach((delay) => window.setTimeout(() => this.polishSelectionSummary(record), delay));
    }

    polishSelectionSummary(record = null) {
      const saved = record?.option ? record : state.get(this.stateKey);
      const nativeOption = saved?.option && !saved.invalidated ? this.optionMap.get(saved.option) : null;
      const matched = Boolean(
        nativeOption
        && String(this.selectedOptionValue()?.value || '') === String(nativeOption.id)
      );

      document.querySelectorAll(`avontic-pdp-selection-summary[data-product-id="${CSS.escape(this.stateKey)}"]`).forEach((summary) => {
        summary.dataset.avGalaxySummary = 'true';
        summary.dataset.avGalaxyFitState = matched ? 'matched' : 'unchecked';

        const eyebrow = summary.querySelector('.av-pdp-selection__eyebrow');
        if (eyebrow && eyebrow.textContent.trim() !== 'Your selection') eyebrow.textContent = 'Your selection';

        const slots = [
          ['[data-av-pdp-essential]', 'model'],
          ['[data-av-pdp-finish]', 'finish'],
          ['[data-av-pdp-state]', 'state'],
          ['[data-av-pdp-price]', 'price']
        ];
        slots.forEach(([selector, slot]) => {
          const value = summary.querySelector(selector);
          const wrapper = value?.closest('div');
          if (wrapper) wrapper.dataset.avGalaxySlot = slot;
        });

        const guidance = summary.querySelector('.av-pdp-selection__guidance');
        if (guidance) {
          guidance.hidden = true;
          guidance.setAttribute('aria-hidden', 'true');
        }

        const confirmButton = summary.querySelector('.av-pdp-selection__confirm');
        if (confirmButton) {
          confirmButton.hidden = true;
          confirmButton.disabled = true;
          confirmButton.tabIndex = -1;
          confirmButton.setAttribute('aria-hidden', 'true');
        }

        const inventoryState = String(summary.dataset.inventoryState || '').toLowerCase();
        const inventoryMessageIsAuthoritative = ['unavailable', 'backorder', 'preorder'].includes(inventoryState);
        const status = summary.querySelector('[data-av-pdp-state]');
        if (status && !inventoryMessageIsAuthoritative) {
          const label = matched ? 'Model match confirmed' : 'Fit not checked';
          if (status.textContent.trim() !== label) status.textContent = label;
        }
      });
    }

    emitVerification(verified, record = null) {
      document.dispatchEvent(new CustomEvent('avontic:pdp-fit-verification', {
        detail: {
          productId: this.stateKey,
          verified: Boolean(verified),
          modelNumber: verified ? String(record?.code || '') : '',
          optionKey: verified ? String(record?.option || '') : ''
        }
      }));
    }
  }

  customElements.define('avontic-galaxy-tab-finder', AvonticGalaxyTabFinder);
  window.AvonticGalaxyTabFinder = Object.freeze({ version: VERSION, models: MODELS.length });
})();

